import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VERSION } from '../../app.constants';
import { JhiLanguageService } from '../../shared/core-utils';
import { LoginService } from '../../shared/login/login.service';
import { LoginPageDetails } from '../../shared/login/login.model';
import { UserProfileModel } from '../../entities/user-profile/model/user-profile.model';
import { LoginContext } from '../../shared/login/login-context';

@Component({
    selector: 'jhi-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: [
        '../login.component.scss'
    ],
    encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {

    version = VERSION;
    pageDetails: LoginPageDetails;
    model: UserProfileModel;

    isFormValid = true;
    isLoading = false;
    errorMessage: string;
    errorFields = [];

    constructor(private context: LoginContext,
                private route: ActivatedRoute,
                private languageService: JhiLanguageService,
                private loginService: LoginService,
                private router: Router,
    ) {
        document.body.classList.add('body-container');
        this.model = this.context.model;
        this.model.email = '';
    }

    ngOnInit(): void {
        this.loginService.getLoginPageDetails().toPromise().then((response) => {
            this.pageDetails = response;
        });
    }

    ngOnDestroy() {
        document.body.classList.remove('body-container');
    }

    async doValidateForgotPassword() {
        this.clearErrors();
        this.isLoading = true;
        const request = {
            email: this.model.email
        };
        try {
            await this.loginService.sendResetEmail(request).toPromise();
        } catch (error) {
        } finally {
            this.isLoading = false;
            this.router.navigate(['/login'], {
                queryParams: { email_sent: 'Y' },
            });
        }
    }

    private displayClientError(errorMsg) {
        this.errorMessage = errorMsg;
        this.isFormValid = false;
        this.isLoading = false;
    }

    private applyValidationErrors(errors) {
        let errorMessage = '';

        Object.keys(errors).forEach((fieldName) => {
            this.errorFields.push(fieldName);
            errorMessage += errorMessage ? (' ' + errors[fieldName]) : errors[fieldName];

        });
        this.displayClientError(errorMessage);
    }

    private clearErrors() {
        // Double check if form is actually invalid, as this function may occasionally be called unnecessarily
        if (!this.isFormValid) {
            // Clear client errors
            this.errorMessage = '';
            this.isFormValid = true;
            this.errorFields = [];
        }
    }
}
